import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { IEssay } from '../../../core/models/essay';

interface UserEssayState {
  essay: IEssay | null;
  isLoading: boolean;
  setEssay: (essay: IEssay) => void;
  setIsLoading: (loading: boolean) => void;
  resetUserEssay: () => void;
}

export const useUserEssayStore = create<UserEssayState>()(
  persist(
    (set) => ({
      essay: null,
      isLoading: false,
      setEssay: (essay: IEssay) => set({ essay: essay }),
      setIsLoading: (loading: boolean) => set({ isLoading: loading }),
      resetUserEssay: () => set({ 
        essay: null,
        isLoading: false,
      })
    }),
    {
      name: 'essay-by-user'
    }
  )
);
